// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__Pm3cF","wrapper":"style_wrapper__y08Bj","close":"style_close__D9oft"};